























import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '@/components/documents/document-models';
import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SegmentInstanceDetails } from './claims-models';

@Component({
  components: {
    OtDocumentList,
    OtDocumentsFilter,
  },
})
export default class OtProjectDocumentsIndex extends Vue {
  // * PROPS
  @Prop() private claimDetails!: SegmentInstanceDetails;

  // * REFS

  // * COMPUTED
  private get organisationGid() {
    return this.claimDetails.project.organisationGid;
  }
  private get projectGid() {
    return this.claimDetails.project.gid;
  }
  private get contractGid() {
    return this.claimDetails.contract.gid;
  }
  private get segmentInstanceGid() {
    return this.claimDetails.gid;
  }
  private get locationDescription() {
    return 'Workflow';
    // return this.claimDetails.locationDescription;
  }

  // * DATA
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Workflow;
  private mode = DocumentListMode.Display;

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }

  // * LIFECYCLE
}
